module.exports = __webpack_public_path__ + "static/media/set-menu.b9e61fa6.svg";